import script from "./SpvPaymentSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./SpvPaymentSuccess.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__